/**************************************************
 * Created by kaili on 2017/12/5 上午9:50.
 **************************************************/
import { Actions, action, node, reducer } from '@ekuaibao/store'
import { QuerySelect } from 'ekbc-query-builder'
import key, { ID } from './key'
import { app as api, app } from '@ekuaibao/whispered'
import { ParsePower } from '@ekuaibao/lib/lib/parsePower'
import { Fetch } from '@ekuaibao/fetch'
import { Resource } from '@ekuaibao/fetch'
import { xor } from 'lodash'
import getWorkerResult from './worker-getresult'
import { GET } from '@ekuaibao/auth'

//form
const toggle = new Resource('/api/common/v1/toggle')
const feeTypes = new Resource('/api/v1/form/feeTypes')
const payees = new Resource('/api/v1/form/payees')
const payeeActionV2 = new Resource('/api/pay/v2/payeeinfoconfigs')
const payerActionV2 = new Resource('/api/pay/v2/payerinfoconfigs')
const specifications = new Resource('/api/form/v1/specificationVersions')
const tripTypes = new Resource('/api/trip/v2/type')
//organization
const staffs = new Resource('/api/v1/organization/staffs')
const staffsV2 = new Resource('/api/v2/organization/staffs')
const glueStaffs = new Resource('/api/glue/v1/organization/staffs')
const departments = new Resource('/api/v1/organization/departments')
const departmentsV2 = new Resource('/api/organization/v2/department')
const externalDepartment = new Resource('/api/v1/organization/externalDepartment')
const role = new Resource('/api/v1/organization/roles')
const roleGroups = new Resource('/api/v1/organization/roleGroups')
const editablefields = new Resource('/api/v1/organization/corporations/editableFields')
const permission = new Resource('/api/glue/v1/organization/permissions')
const delegate = new Resource('/api/v1/organization/delegate')
const temporaryToken = new Resource('/api/account/v2/session/getAccessToken')
//corporationset
const corporationSet = new Resource('/api/v1/corporationset')
//flow
const referables = new Resource('/api/flow/v2/referables')
const backlogs = new Resource('/api/flow/v2/backlogs')
const flows = new Resource('/api/flow/v1/flows')
const property = new Resource('/api/flow/v2/propertySet')
//basedata
const enumItems = new Resource('/api/v1/basedata/enumItems/byEnumCode')
const powers = new Resource('/api/charge/powers')
const aiAutofillPermission = new Resource('/api/engine/hab/agent/permission/abilities')
const budgetMsg = new Resource('/api/v1/budget/report/message/flow')
const loanpackage = new Resource('/api/v1/loan/loanInfo')
const pay = new Resource('/api/pay/v1')
const third = new Resource('/api/ekbmall/v1/third')
const currencyAction = new Resource('/api/v2/currency')
const carbonCopy = new Resource('/api/flow/v2/carbonCopy')
const message = new Resource('/api/message/v1/messages')
const dimensionItems = new Resource('/api/v1/basedata/dimensionItems')
const fieldMap = new Resource('/api/v1/mapping/fieldMapping')
const lastChoice = new Resource('/api/flow/v2/lastChoice')
const setOrganization = new Resource('/api/v2/organization')
const accounts = new Resource('/api/pay/v2/accounts')
const newAccounts = new Resource('/api/v2/pay/accounts')
const assistPlatform = new Resource('/api/assistPlatform/log')
const attachments = new Resource('/api/v1/attachment/attachments')
const spaceAction = new Resource('/api/dingtalk/v2/cspace')
const corgSwitch = new Resource('/api/orgSwitch')
const downloadAction = new Resource('/api/app/download')
const safeSetting = new Resource('/api/v2/corporationset/watermark')
const safeSettingV3 = new Resource('/api/v3/safeSetting')
const riskWarning = new Resource('/api/flow/v2/riskwarning')
const condition = new Resource('/api/form/v2/condition')
const delegateAccess = new Resource('/api/glue/v1/organization/delegateSet')
const messageCenterConfig = new Resource('/api/message/v1/messageCenterConfig')
const tradeeditionAction = new Resource('/api/v1/tradeedition')
const exportIsTimeLimit = new Resource('/api/flow/v2/exportIsTimeLimit')
const isWhiteList = new Resource('/api/menu/v2/questionnaires/isWhiteList')
const isUpgrade = new Resource('/api/supplier/v3/corppayment/isUpgrade')
const invoiceAction = new Resource('/api/v2/invoice')
const authEnv = new Resource('/api/v2/environment')
const asyncPrint = new Resource('/api/v1/print/asyn')
const supplierPortalAction = new Resource('/api/v1/corporatebanking/supplierPortal')

// 查询附件是否可以被下载
const fileCanDownload = new Resource('/api/v1/attachment/attachments/allowDownload')

const getUrlParams = (key) => {
  const params = new URLSearchParams(window.location.search)
  return params.get(key) ?? undefined
}

function generateDataKey(data = {}, prefix = '') {
  if (data === null) return prefix || ''
  const keys = Object.keys(data).sort()
  const keyStr = keys.map((key) => `${key}=${JSON.stringify(data[key] ?? '')}`).join(',')
  return prefix ? `${prefix}:${keyStr}` : keyStr
}

function enableStaffSwitch() {
  const { enableStaffApiSwitch } = app.require('@lib/featbit')
  return enableStaffApiSwitch?.() || false
}

const _getStaffPromiseMap = {}
const presetShowFieldList = ['reconcileResultForm']
class CommonActions extends Actions {
  static pluginName = ID

  /**
   * 获取已审批代办列表的数量
   * @param state
   * @returns {{payload : *}}
   */
  @reducer((action) => {
    if (action.state === 'APPROVING') {
      return { approving: action.payload.count }
    } else if (action.state === 'SENDING') {
      return { sending: action.payload.count }
    } else if (action.state === 'RECEIVING') {
      return { receiving: action.payload.count }
    }
    return { paying: action.payload.count }
  })
  @node('backlogCount', { approving: 0, paying: 0, sending: 0, receiving: 0 }, true)
  @action
  getBackLogCount(state) {
    let query = new QuerySelect().filterBy(`type!="permit"`)
    if (state === 'APPROVING' && window.__PLANTFORM__ === 'MC') {
      query = query.filterBy(`state.in("${state}")&&(crossCorp==true)`)
    } else {
      query = query.filterBy(`state.in("${state}")`)
    }
    return {
      payload: backlogs.POST('/count', query.value()),
      state: state,
    }
  }

  /**
   * 获取已审批代办列表的数量,合并多个请求优化
   * @param state
   * @returns {{payload : *}}
   */
  @reducer((action) => {
    var defaultValue = { approving: 0, paying: 0, sending: 0, receiving: 0 }
    var payload = JSON.stringify(action.payload || {}).toLocaleLowerCase()
    var data = Object.assign(defaultValue, JSON.parse(payload))
    return data
  })
  @node('backlogCount', { approving: 0, paying: 0, sending: 0, receiving: 0 }, true)
  @action
  getBackLogCountNew(params) {
    return {
      payload: backlogs.GET(`/countBackLogByState/${params}`, {}, undefined, {
        hiddenLoading: true,
      }),
    }
  }

  /**
   * 获取当前人是否可以下载附件
   * @returns
   */
  @reducer(function (action) {
    if (action.typeName === 'setValue') {
      return action.data
    }
    return action.payload.value
  })
  @node('fileCanDownload', false)
  @action
  getFileCanDownload(typeName, data) {
    return typeName
      ? { typeName, data }
      : { payload: fileCanDownload.GET('/', undefined, undefined, { hiddenLoading: true }) }
  }

  /**
   * 获取当前企业的安全设置信息
   * @returns
   */
  @reducer(function (action) {
    if (action.typeName === 'setValue') {
      return { ...action.data }
    }
    return action.payload.value || {}
  })
  @node('safeSetting', {})
  @action
  getSafeSetting(typeName, data) {
    return typeName
      ? { typeName, data }
      : { payload: safeSetting.GET('/', undefined, undefined, { hiddenLoading: true }) }
  }

  /**
   * 获取收款人信息
   * @returns {{payload : *}}
   */
  @reducer((action) => action.payload.items)
  @node('payees', [])
  @action
  getPayees(param) {
    return {
      payload: accounts.GET(
        '/mine',
        {
          start: 0,
          count: 2999,
          filter: 'active == true',
          // join: 'staffId,staffId,/v1/organization/staffs',
          ...param,
        },
        undefined,
        { hiddenLoading: true },
      ),
    }
  }

  @reducer((action) => action.payload.value || {})
  @node('defaultPayee')
  @action
  getDefaultPayee() {
    return {
      payload: accounts.GET('/default'),
    }
  }

  /**
   * 获取快速报销消费类型树
   * @param params
   * @returns {{payload : *}}
   */
  @reducer((action) => {
    const tree = action.payload.items || [],
      list = [],
      map = {}
    if (tree.length) {
      const fn = (children) =>
        children.forEach((line) => {
          list.push(line)
          line.children && line.children.length && fn(line.children)
        })
      fn(tree)
      list.forEach((o) => (map[o.id] = o))
    }
    return { data: tree, list, map }
  })
  @node('quickFeetypes', { data: [], list: [], map: {} })
  @action
  getQuickFeetypes(params) {
    return { payload: feeTypes.GET('/quickExpenseList', params) }
  }

  /**
   * 获取消费类型树
   * @param params
   * @returns {{payload : *}}
   */
  @reducer((action) => {
    const tree = action.payload.items || [],
      list = [],
      map = {}
    if (tree.length) {
      const fn = (children) =>
        children.forEach((line) => {
          list.push(line)
          line.children && line.children.length && fn(line.children)
        })
      fn(tree)
      list.forEach((o) => (map[o.id] = o))
    }
    return { data: tree, list, map }
  })
  @node('feetypes', { data: [], list: [], map: {} })
  @action
  getFeeTypes(params) {
    return { payload: feeTypes.GET('/tree/active', params) }
  }

  /**
   * 获取消费全部类型树
   * @param params
   * @returns {{payload : *}}
   */
  @reducer((action) => {
    const tree = action.payload.items,
      list = [],
      map = {}
    if (tree.length) {
      const fn = (children) =>
        children.forEach((line) => {
          list.push(line)
          line.children && line.children.length && fn(line.children)
        })
      fn(tree)
      list.forEach((o) => (map[o.id] = o))
    }
    return { data: tree, list, map }
  })
  @node('feetypesAll', { data: [], list: [], map: {} })
  @action
  getFeeTypesAll(params) {
    const para = {
      ...params,
      join: 'id,feetypeTemplate,/form/v2/specifications/feeType',
      join$2: 'children.id,feetypeTemplate,/form/v2/specifications/feeType',
    }
    return { payload: feeTypes.GET('/tree', para) }
  }

  /**
   * 获取用户信息
   * @param params
   * @returns {{payload, isCheck : boolean}}
   */
  @reducer((action) => {
    const data = action.payload
    const { staff } = data
    if (!staff.corporationId) {
      api.go('/no-org')
    }
    action.isCheck && api.emit(`${key.ID}:user:checked`, data)
    return { data, staff, corporation: staff.corporation }
  })
  @node('userinfo', { data: {} })
  @action
  getUserInfo(params) {
    const data = {
      ...params,
      join: 'staff.corporationId,corporation,/v1/organization/corporations',
      join$1: 'staff.departments,departments,/v1/organization/departments',
      join$2: 'staff.id,autograph,/v1/basedata/autographs',
      join$4: 'staff.id,bankCardNums,/v1/organization/staffs/bankCardNum',
      join$5: 'staff.defaultDepartment,defaultDepartment,/v1/organization/departments',
    }
    /**
     * slRn4Qikh5R9Ug: 广州市中大管理咨询有限公司的企业id
     * PRP-22568 工单PO-20200703-1121
     * 用户登陆企业微信电脑端无法进入，界面显示空白
     * 暂通过取消roles的join解决
     */
    // @i18n-ignore
    if (Fetch.ekbCorpId !== 'slRn4Qikh5R9Ug')
      data['join$3'] =
        'staff.id,roles,/v1/organization/staffs/role?join=values.roleDefId,roleDef,/v1/organization/roles&join=values.properties.项目,project,/v1/basedata/dimensionItems/fullName'

    return {
      payload: staffs
        .GET('/me', data, undefined, { hiddenLoading: true })
        .then((resp) => resp.value),
      isCheck: params ? params.type === 'check' : false,
    }
  }

  /**
   * 获取已授权激活员工列表
   * @returns {{payload : *}}
   */
  @reducer((action) => action.payload.items)
  @node('staffs', [])
  @action
  getStaffsAuthorized(args) {
    if (enableStaffSwitch()) {
      return this.getStaffsAuthorizedV2(args)
    }

    let items = [],
      pages = 1,
      /**
       * slRn4Qikh5R9Ug: 广州市中大管理咨询有限公司的企业id
       * PRP-15313 工单03#4357
       * pageSize > 150时，下面的authorized接口会报空指针异常，影响范围广泛，未找到原因
       * 暂通过改小pageSize解决此hotfix
       */
      pageSize = Fetch.ekbCorpId === 'slRn4Qikh5R9Ug' ? 100 : 3000
    const params = {
      start: 0,
      count: pageSize,
    }
    // const TEST_CORP = ['VRm3Kg2sYl0biL', 'uzU7pcWfScck00', 'ID_3qzOi9p0oEM', '71I8RhRm6I0g00']
    if (!!args?.needRole) {
      params.join =
        'id,roles,/v1/organization/staffs/role?join=values.roleDefId,roleDef,/v1/organization/roles'
    }
    const getStaffsFn = () => {
      const hiddenLoading = !!api.getState()['@common']?.staffs?.length
      return glueStaffs.GET('/authorized', params, null, { hiddenLoading }).then(async (resp) => {
        if (resp.count !== 0) {
          items = items.concat(resp.items)
          params.start = pages * pageSize
          pages++
          return getStaffsFn()
        }
        await api.dispatch(this.authStaffDepartmentStaffMap(items))
        await api.dispatch(this.authStaffStaffMap(items))
        return { items }
      })
    }

    return { payload: getStaffsFn() }
  }

  getStaffsAuthorizedV2(args) {
    const dataKey = generateDataKey(args, 'getStaffsAuthorizedV2')
    if (_getStaffPromiseMap[dataKey]) {
      return { payload: _getStaffPromiseMap[dataKey] }
    }
    let items = [],
      pages = 1,
      pageSize = Fetch.ekbCorpId === 'slRn4Qikh5R9Ug' ? 100 : 3000

    const params = {
      query: {
        limit: {
          start: 0,
          count: pageSize,
        },
        filterBy: '(authState==true)',
      },
      maskSensitiveInfo: true,
    }

    const qs = {}
    // const TEST_CORP = ['VRm3Kg2sYl0biL', 'uzU7pcWfScck00', 'ID_3qzOi9p0oEM', '71I8RhRm6I0g00']
    if (!!args?.needRole) {
      qs.join =
        'id,roles,/v1/organization/staffs/role?join=values.roleDefId,roleDef,/v1/organization/roles'
    }

    const getStaffsFn = () => {
      const hiddenLoading = !!api.getState()['@common']?.staffs?.length
      return staffsV2.POST('/list', params, qs, null, { hiddenLoading }).then(async (resp) => {
        items = items.concat(resp.items || [])
        if (resp.count > items.length) {
          params.query.limit.start = pages * pageSize
          pages++
          return getStaffsFn()
        }
        await api.dispatch(this.authStaffDepartmentStaffMap(items))
        await api.dispatch(this.authStaffStaffMap(items))
        return { items }
      })
    }

    const promise = getStaffsFn()
    _getStaffPromiseMap[dataKey] = promise
    promise.finally(() => {
      _getStaffPromiseMap[dataKey] = undefined
    })
    return { payload: promise }
  }

  @reducer((action) => action.payload)
  @node('authStaffDepartmentStaffMap', {})
  @action
  authStaffDepartmentStaffMap(staffs) {
    const parseStaffsToStaffDepartMap = (staffs = []) => {
      const departmentStaffMap = {}
      if (!staffs?.length) {
        return departmentStaffMap
      }
      staffs.forEach((staff) => {
        staff.departments.forEach((deptId) => {
          let staffObj = departmentStaffMap[deptId]
          if (!staffObj) {
            staffObj = { staffList: [], staffMap: {} }
            departmentStaffMap[deptId] = staffObj
          }
          if (!staffObj.staffMap[staff.id]) {
            staffObj.staffList.push(staff)
            staffObj.staffMap[staff.id] = staff
          }
        })
      })
      return departmentStaffMap
    }
    return { payload: parseStaffsToStaffDepartMap(staffs) }
  }

  /**
   * 解析员工数组为员工映射对象
   * @param {Array} staffs - 员工数组
   * @returns {Object} 员工映射对象，以员工ID为键
   */
  parseStaffsToStaffMap(staffs = []) {
    const staffMap = {}
    if (!staffs?.length) {
      return staffMap
    }
    staffs.forEach((staff) => {
      staffMap[staff.id] = staff
    })
    return staffMap
  }

  @reducer((action) => action.payload)
  @node('authStaffStaffMap', {})
  @action
  authStaffStaffMap(staffs) {
    return { payload: this.parseStaffsToStaffMap(staffs) }
  }

  /**
   * 获取所有激活员工映射（支持追加模式，手动合并优化性能）
   * @param {Array} staffs - 员工数组
   * @returns {{payload: Object}} 包含员工映射的payload对象
   */
  @reducer((action, state) => {
    // 获取当前状态中的员工映射，如果不存在则使用空对象
    const currentStaffMap = state.allStaffActiveStaffMap || {}
    // 手动合并，避免创建新对象的开销
    const newStaffMap = { ...currentStaffMap }

    // 只遍历新增的数据
    for (const staffId in action.payload) {
      if (action.payload.hasOwnProperty(staffId)) {
        newStaffMap[staffId] = action.payload[staffId]
      }
    }

    return newStaffMap
  })
  @node('allStaffActiveStaffMap', {})
  @action
  allStaffActiveStaffMap(staffs) {
    return { payload: this.parseStaffsToStaffMap(staffs) }
  }

  /**
   * 新获取已授权激活员工列表（支持分页）
   * @returns {{payload : *}}
   */
  @reducer((action) => ({
    items: action.payload.items,
    count: action.payload.count,
  }))
  @node('staffsData')
  @action
  getStaffsAuthorizedAssist(data) {
    !data && (data = { start: 0, count: 20, departmentId: '' })
    const params = {
      ...data,
      // @i18n-ignore
      join: 'id,roles,/v1/organization/staffs/role?join=values.roleDefId,roleDef,/v1/organization/roles',
    }

    return { payload: glueStaffs.GET('/authorized/assist', params) }
  }

  /**
   * 获取异步打印控制配置
   * @returns {{payload : *}}
   */
  @reducer((action) => ({
    items: action.payload.items,
  }))
  @node('asyncPrintConfig', {
    items: [
      {
        type: 'invoice',
        num: 5,
      },
      {
        type: 'flow',
        num: 20,
      },
      {
        type: 'details',
        num: 60,
      },
    ],
  })
  @action
  getAsyncPrintConfig() {
    const params = {
      corpId: Fetch.ekbCorpId,
    }

    return { payload: asyncPrint.GET('', params, undefined, { hiddenLoading: true }) }
  }

  fnGetStaffsAuthorized(url, staffId, args) {
    let items = [],
      pages = 1,
      /**
       * slRn4Qikh5R9Ug: 广州市中大管理咨询有限公司的企业id
       * PRP-15627 工单03#4357
       * pageSize > 150时，下面的authorized接口会报空指针异常，影响范围广泛，未找到原因
       * 暂通过改小pageSize解决此hotfix
       */
      pageSize = Fetch.ekbCorpId === 'slRn4Qikh5R9Ug' ? 100 : 3000
    //pageSize = 1000
    const params = {
      start: 0,
      count: pageSize,
      // @i18n-ignore
      join$1: 'defaultDepartment,defaultDepartment,/v1/organization/departments',
      staffId,
    }
    const TEST_CORP = ['VRm3Kg2sYl0biL', 'uzU7pcWfScck00', 'ID_3qzOi9p0oEM', '71I8RhRm6I0g00']
    if (!args?.isRole && !TEST_CORP.includes(Fetch.ekbCorpId)) {
      params.join =
        'id,roles,/v1/organization/staffs/role?join=values.roleDefId,roleDef,/v1/organization/roles'
    }

    // authorized/dingtalk  此逻辑在钉钉环境内会根据钉钉的权限进行控制，在别的环境换返回全员
    const getVisibilityStaffsFn = () => {
      return glueStaffs.GET(url, params).then((resp) => {
        items = items.concat(resp.items)
        if (pageSize === resp?.count) {
          params.start = pages * pageSize
          pages++
          return getVisibilityStaffsFn()
        }
        return { items }
      })
    }
    return getVisibilityStaffsFn()
  }

  fnGetStaffsAuthorizedV2(staffId, args) {
    let items = [],
      pages = 1,
      /**
       * slRn4Qikh5R9Ug: 广州市中大管理咨询有限公司的企业id
       * PRP-15627 工单03#4357
       * pageSize > 150时，下面的authorized接口会报空指针异常，影响范围广泛，未找到原因
       * 暂通过改小pageSize解决此hotfix
       */
      pageSize = Fetch.ekbCorpId === 'slRn4Qikh5R9Ug' ? 100 : 3000
    //pageSize = 1000
    const params = {
      query: {
        limit: {
          start: 0,
          count: pageSize,
        },
        filterBy: '(authState==true)',
      },
      maskSensitiveInfo: true,
      visible: true,
      visibleRestrictedStaffId: typeof staffId === 'string' ? staffId : undefined,
    }
    const qs = {
      join$1: 'defaultDepartment,defaultDepartment,/v1/organization/departments',
    }
    const TEST_CORP = ['VRm3Kg2sYl0biL', 'uzU7pcWfScck00', 'ID_3qzOi9p0oEM', '71I8RhRm6I0g00']
    if (!args?.isRole && !TEST_CORP.includes(Fetch.ekbCorpId)) {
      qs.join =
        'id,roles,/v1/organization/staffs/role?join=values.roleDefId,roleDef,/v1/organization/roles'
    }

    const getVisibilityStaffsFn = () => {
      return staffsV2.POST('/list', params, qs).then((resp) => {
        items = items.concat(resp.items || [])
        if (resp.count > items.length) {
          params.query.limit.start = pages * pageSize
          pages++
          return getVisibilityStaffsFn()
        }
        return { items }
      })
    }

    return getVisibilityStaffsFn()
  }

  /**
   * 获取可见性员工列表
   * 普通用户可见的界面：包括
   单据中选择的部门架构（选人组件、选部门组件），和评论艾特功能的架构，以及委托授权的架构（按提交人的权限），还有审批流选择人员、转交审批，申请事项的转交、共享
   * @returns {{payload : *}}
   */
  @reducer((action) => action.payload.items)
  @node('staffsVisibility', [])
  @action
  getVisibilityStaffsAuthorized(url, staffId, args) {
    if (enableStaffSwitch()) {
      return { payload: this.fnGetStaffsAuthorizedV2(staffId, args) }
    }
    return { payload: this.fnGetStaffsAuthorized('/visibility/authorized/dingtalk', staffId, args) }
  }

  @reducer((action) => action.payload.items)
  @node('commonStaffsVisibility', [])
  @action
  getCommonVisibilityStaffsAuthorized(staffId, args) {
    if (enableStaffSwitch()) {
      return { payload: this.fnGetStaffsAuthorizedV2(staffId, args) }
    }
    return { payload: this.fnGetStaffsAuthorized('/visibility/authorized', staffId, args) }
  }

  /**
   * 获取全部已激活员工列表
   * @returns {{payload : *}}
   */
  @reducer((action) => ({
    data: action.payload.items,
    count: action.payload.count,
  }))
  @node('staffsActives', { data: [] })
  @action
  getStaffsActives(ags) {
    return this.getStaff(ags)
  }

  /**
   * 根据条件获取员工列表
   * params:{range:'all\true\false'}
   * @returns {{payload : *}}
   */
  @reducer((action) => ({
    data: action.payload.items,
    count: action.payload.count,
  }))
  @node('rangeStaffs', { data: [] })
  @action
  getRangeStaffs(params) {
    return this.getStaff(params)
  }

  /**
   * 获取限制范围内的人员
   * @returns {{payload : *}}
   */
  @reducer((action) => ({
    data: action.payload.items,
    count: action.payload.count,
  }))
  @node('staffRangeByRule', { data: [] })
  @action
  getStaffRangeByRule(ags) {
    return this.getStaffByRule(ags)
  }
  //根据人员可选范围id获取人员
  getStaffByRule(data = {}) {
    let items = []
    let pages = 1
    const pageSize = 2999
    const params = {
      start: 0,
      count: pageSize,
      ...data,
    }
    const getStaffsByRule = () => {
      return condition.POST('/getStaffList/$ruleId', params).then((resp) => {
        items = items.concat(resp.items)
        if (resp.items.length === pageSize) {
          params.start = pages * pageSize
          pages++
          return getStaffsByRule()
        }
        return { items }
      })
    }
    return { payload: getStaffsByRule() }
  }

  getStaff(data = {}) {
    const dataKey = generateDataKey(data, 'getStaff')
    if (_getStaffPromiseMap[dataKey]) return { payload: _getStaffPromiseMap[dataKey] }

    const getStaffs = async () => {
      let items = []
      let pages = 1
      const pageSize = 2999
      const params = {
        start: 0,
        count: pageSize,
        ...data,
      }
      let resp
      while (true) {
        resp = await staffs.GET('/actives', params, undefined, { hiddenLoading: true })
        items = items.concat(resp.items)
        if (resp.items.length !== pageSize) {
          break
        }
        params.start = pages * pageSize
        pages++
      }
      api.dispatch(this.allStaffActiveStaffMap(items))
      return { items }
    }

    const promise = getStaffs()
    _getStaffPromiseMap[dataKey] = promise
    promise.finally(() => {
      _getStaffPromiseMap[dataKey] = undefined
    })
    return { payload: promise }
  }

  @reducer((action) => action.payload.items)
  @action
  getStaffsByIds(params) {
    return { payload: staffs.GET('/[ids]', params) }
  }

  /**
   * 获取已同步未授权员工列表
   * @returns {{}}
   */
  @reducer((action, state) => {
    const staffsAuthorized = state.staffs.map((el) => el.id)
    const staffsAll = state.staffsActives.data.map((el) => el.id)
    return xor(staffsAuthorized, staffsAll)
  })
  @node('staffsBlacklist', [])
  @action
  getStaffsDisabledUsers() {
    return {}
  }

  @reducer((action) => action.payload.items)
  @node('staffsAdmin', [])
  @action
  getStaffsByPermission(data) {
    const params = { ...data, name: 'SYS_ADMIN' }
    return { payload: staffs.GET('/byPermission', params) }
  }

  @reducer(function (action, state) {
    if (action.typeName === 'worker') {
      return { ...action.data }
    } else {
      const data = action.payload.items
      if (data.length) {
        api.dispatch(this.getDepartmentTree('worker', getWorkerResult('getDepartmentsData', data)))
      }
      return {
        data,
        noRootPathMap: {},
        pathMap: {},
        enPathMap: {},
        noRootEnPathMap: {},
        list: [],
        mapData: {},
        ...state.department,
      }
    }
  })
  @node('department', {})
  @action
  getDepartmentTree(typeName, data) {
    return typeName
      ? { typeName, data }
      : { payload: departments.GET('/tree/actives', undefined, undefined, { hiddenLoading: true }) }
  }

  @reducer(function (action, state) {
    if (action.typeName === 'worker') {
      return { ...action.data }
    } else {
      const data = action.payload.items
      if (data.length) {
        api.dispatch(
          this.getDepartmentTreeVirtual('worker', getWorkerResult('getDepartmentsData', data)),
        )
      }
      return {
        data,
        noRootPathMap: {},
        pathMap: {},
        enPathMap: {},
        noRootEnPathMap: {},
        list: [],
        mapData: {},
        ...state.departmentVirtual,
      }
    }
  })
  @node('departmentVirtual', {})
  @action
  getDepartmentTreeVirtual(typeName, data, params = {}) {
    return typeName
      ? { typeName, data }
      : { payload: departments.GET('/tree/actives', { ...params }) }
  }

  // 获取新的部门接口（支持分页）
  @reducer(function (action) {
    if (action.typeName === 'worker') {
      return { ...action.data }
    } else {
      const data = action.payload.items
      if (data.length) {
        api.dispatch(
          this.getDepartmentTreeNew('worker', getWorkerResult('getDepartmentsData', data)),
        )
      }

      let treeData = []
      treeData = data.map((item) => {
        item.children = []
        return item
      })
      return {
        data: treeData,
        noRootPathMap: {},
        pathMap: {},
        list: [],
        mapData: {},
        enPathMap: {},
        noRootEnPathMap: {},
      }
    }
  })
  @node('departmentNew', { data: [] })
  @action
  getDepartmentTreeNew(typeName, data, params = {}) {
    const { start = 0, count = 50, parentId = '' } = params
    const paramsData = {
      limit: {
        start,
        count,
      },
      filterBy: '(active == true)',
    }
    const query = {
      corpId: Fetch.corpId,
      accessToken: Fetch.accessToken,
      parentId,
    }
    return typeName
      ? { typeName, data }
      : { payload: departments.POST(`/tree/flat/$corpId`, paramsData, query), params }
  }

  // 获取部门搜索结果
  @reducer()
  @node('searchDepartmentData', [])
  @action
  getSearchDepartment(params) {
    const filterBy = `(active == true && (name.contains(\"${params.searchText}\")||code.contains(\"${params.searchText}\")))`
    const query = { filterBy }
    return { payload: departments.POST('/search/assist', query) }
  }

  @reducer()
  @node('costCenter', {})
  @action
  getCostCenterById(costCenterId) {
    return { payload: dimensionItems.GET('/[costCenterId]', { costCenterId }) }
  }

  @reducer()
  @node('dimensionItemValue', {})
  @action
  getDimensionValueById(params) {
    return { payload: dimensionItems.GET('/$id', params) }
  }

  @reducer(function (action, state) {
    if (action.typeName === 'worker') {
      return { ...action.data }
    } else {
      const data = action.payload.items
      data.length
        ? api.dispatch(
            this.getExternalDepartmentTree('worker', getWorkerResult('getDepartmentsData', data)),
          )
        : api.dispatch(this.getExternalDepartmentTree('init'))
      if (action.typeName === 'init') {
        api.dispatch(actions.getExternalList())
        return { ...action.data }
      }
      return {
        data,
        noRootPathMap: {},
        pathMap: {},
        list: [],
        mapData: {},
        enPathMap: {},
        noRootEnPathMap: {},
        ...state.externalDepartment,
      }
    }
  })
  @node('externalDepartment', {})
  @action
  getExternalDepartmentTree(typeName, data) {
    if (typeName === 'init') {
      return {
        typeName,
        payload: externalDepartment.POST('/initDept', undefined, undefined, undefined, {
          hiddenLoading: true,
        }),
      }
    } else {
      return typeName
        ? { typeName, data }
        : {
            payload: externalDepartment.GET('/tree', undefined, undefined, { hiddenLoading: true }),
          }
    }
  }

  @reducer()
  @node()
  @action
  getDepartmentById(ids) {
    return { payload: departments.GET('/withFullName/$[ids]', { ids }) }
  }

  @reducer(function (action) {
    if (action.typeName === 'worker') {
      return { ...action.data }
    } else {
      const data = action.payload.items
      if (data.length) {
        api.dispatch(
          this.getVisibilityDepartmentTree(
            null,
            'worker',
            getWorkerResult('getDepartmentsData', data),
          ),
        )
      }
      return {
        data,
        noRootPathMap: {},
        pathMap: {},
        list: [],
        mapData: {},
        enPathMap: {},
        noRootEnPathMap: {},
      }
    }
  })
  @node('departmentVisibility', {})
  @action
  getVisibilityDepartmentTree(staffId, typeName, data) {
    return typeName
      ? { typeName, data }
      : {
          payload: departments.GET('/tree/visibility/actives', { staffId }, undefined, {
            hiddenLoading: true,
          }),
        }
  }

  @reducer((action) => action.payload.items)
  @action
  getDeptById(id) {
    return { payload: departments.GET('/$id', { id }) }
  }

  @reducer((action) => action.payload.items)
  @node('roleList', [])
  @action
  getRoleList(data) {
    const params = { start: 0, count: 2999, ...data }
    return { payload: role.GET('', params) }
  }

  @reducer((action) => action.payload.items)
  @node('roleGroupList', [])
  @action
  getRoleGroups() {
    return { payload: roleGroups.GET() }
  }

  @reducer((action) => action.payload.items[0] || {})
  @node('budgetMsg', {})
  @action
  getBudgetMsg(ids) {
    return { payload: budgetMsg.GET('/[ids]', { ids }) }
  }

  @reducer((action) => action.payload.items)
  @node('delegators', [])
  @action
  getDelegators() {
    const data = {
      join$1: 'defaultDepartment,defaultDepartment,/v1/organization/departments',
    }
    return { payload: delegate.GET('/byDelegateeId', data) }
  }

  @reducer((action) => action.payload)
  @node('loanPackage', {})
  @action
  listLoanPackageBySubmitter(param) {
    const {
      state = 'REPAID',
      start = 0,
      count = 999,
      filters = '',
      flowId,
      id,
      method = 'get',
    } = param || {}

    if (method === 'get') {
      return {
        payload: loanpackage.GET('/byOwnerIdAndState/$id', param, null, { hiddenLoading: true }),
      }
    }

    const query = new QuerySelect()
      .limit(start, count)
      .filterBy(`state.in("${state}")`)
      .filterBy(filters)
      .value()

    return {
      payload: loanpackage.POST('/byOwnerIdAndState/$id/search', { id, flowId, ...query }),
    }
  }

  @reducer((action) => action.payload)
  @action
  getDimensionById(param) {
    return { payload: dimensionItems.POST('/byEntity/$id/search', param) }
  }

  // 获取配置的开关接口 https://hose2019.feishu.cn/docx/LJZKdKAu2oB2iAxoS1Tcv30inzV
  @reducer((action) => {
    return action?.payload?.value || false
  })
  @node('feetypeTableEdit', false)
  @action
  getFeetypeTableEdit() {
    return { payload: toggle.GET('/byCorpId', { key: 'tg_feetype_table_edit' }) }
  }

  @reducer((action) => {
    //为数据中的元素添加fullPath
    function addFullPath(list = [], fullPathName = '') {
      list.forEach((el) => {
        if (el.dimensionId) {
          // 针对“扩展档案”根据当前的国际化配置显示
          const nameByLocale = i18n.currentLocale === 'en-US' ? el.enName : el.name
          el.fullPath = fullPathName ? `${fullPathName}/${nameByLocale}` : nameByLocale
        } else {
          el.fullPath = fullPathName ? `${fullPathName}/${el.name}` : el.name
        }
        if (el.children) {
          el.children = addFullPath(el.children, el.fullPath)
        }
        return el
      })
      return list
    }
    addFullPath(action.payload.items)
    return action.payload
  })
  @node('dimensionValue', {})
  @action
  getDimensionItemsByPropertyId(param) {
    const { withVisibility = true, ...others } = param
    return {
      id: name,
      payload: referables.GET(`/$name`, { withVisibility, ...others }),
    }
  }

  @reducer((action) => action.payload.items)
  @node('editableFields', [])
  @action
  getEditableFields() {
    return { payload: editablefields.GET() }
  }

  /**
   * 获取支付账户相关接口
   * @param active
   * @returns {{active : boolean, payload : *}}
   */
  @reducer((action, state) => {
    const {
      payload: { items },
      active,
    } = action

    let list = items
    if (!state.powers.Wallet) {
      list = items.filter((o) => o.sort !== 'WALLET')
    }

    if (!active) {
      return { list }
    }
    return { activeList: list }
  })
  @node('payAccount', { list: [], activeList: [] }, true)
  @action
  getPayAccountList(active = false, data) {
    const filter = active ? '(asPayer==true&&active==true)' : 'asPayer==true'
    const params = {
      start: 0,
      count: 2999,
      filter,
      // join: 'staffId,staffId,/v1/organization/staffs'
    }
    if (data) {
      params.flowIds = [data.id]
    }
    return {
      active,
      payload: data ? newAccounts.POST('/actives/filter', params) : accounts.GET('', params),
    }
  }

  /**
   * 获取支付账户相关新接口
   * @param filter
   * @returns {{payload : *}}
   */
  @reducer((action) => {
    const {
      payload: { items, count },
      active,
    } = action

    let list = items
    if (!api.getState()['@common'].powers.Wallet) {
      list = items.filter((o) => o.sort !== 'WALLET')
    } else {
      const isOpened = list.filter((o) => o.sort === 'WALLET').length > 0
      if (!isOpened) {
        list.unshift({
          accountName: '企业钱包',
          sort: 'WALLET',
          isOpened: !isOpened,
          active: true,
        })
      }
    }

    if (!active) {
      return { list, count }
    }
    return { activeList: list }
  })
  @node('newPayAccount', { list: [], activeList: [] }, true)
  @action
  getNewPayAccountList(filter = { asPayer: true, start: 0, count: 1000 }) {
    const url = `?filter=(asPayer == ${filter.asPayer})&start=${filter.start}&count=${filter.count}`
    return { payload: accounts.GET(url, { join: 'bankLinkId,bankLinkId,/pay/v1/banks' }) }
  }

  /**
   * 获取当前登录人可使用的支付列表
   *
   */
  @reducer((action) => action.payload.items)
  @node('payAccountsVisibilityList', [])
  @action
  getPayAccountsVisibilityList() {
    return { payload: pay.GET('/accounts/visibility') }
  }

  @reducer((action) => action.payload.items)
  @action
  getFullName(ids) {
    return { payload: dimensionItems.POST(`/fullName`, { ids }) }
  }

  @reducer((action) => action.payload.items)
  @action
  getFullNameById(ids) {
    return { payload: dimensionItems.POST(`/fullName/byId`, { ids }) }
  }

  @reducer((action) => action.payload.items)
  @action
  getFullNameById(ids) {
    return { payload: dimensionItems.POST(`/fullName/byId`, { ids }) }
  }

  @reducer((action) => action.payload.items)
  @node('provinceList', [])
  @action
  getProvinceList() {
    return { payload: pay.GET('/banks/provinces') }
  }

  @reducer((action) => action.payload.items)
  @node('cityList', [])
  @action
  getCityList(data) {
    return { payload: pay.GET('/banks/cities', data) }
  }

  @reducer((action) => action.payload.items)
  @node('branchList', [])
  @action
  getBranchList(data) {
    return { payload: pay.GET('/banks/branches', data) }
  }

  @reducer((action) => action.payload.items)
  @node('bankList', [])
  @action
  getBankList(data) {
    return { payload: pay.GET('/banks/banks', data) }
  }

  @reducer((action) => action.payload.items)
  @node('channelList', [])
  @action
  getChannelList() {
    return { payload: pay.GET('/accounts/corporationChannels') }
  }

  @reducer((action) => action.payload.items)
  @node('payerInfo', [])
  @action
  getPayerInfo(param = {}) {
    const data = {
      join: 'visibility.staffs,staffs,/v1/organization/staffs',
      join$1: 'visibility.departments,departments,/v1/organization/departments',
      join$2: 'visibility.roles,roles,/v1/organization/roles',
    }
    return { payload: corporationSet.GET('/payerinfo', { ...data, ...param }) }
  }

  /**
   * 获取全局字段列表
   * @returns {{payload : *}}
   */
  @reducer((action) => {
    let data = action.payload.items
    if (!data) {
      return {
        data: [],
        extension: [],
        preset: [],
        apportionField: {},
        splitCalField: {},
        baseDataPropertiesMap: {},
        amortizesField: {},
      }
    }
    const extension = data.filter((v) => !v.ability)
    const preset = data.filter((v) => v.ability)
    const apportion = preset.filter((v) => v.ability === 'apportion')
    const apportionField = preset.find((o) => o.name === 'apportions')
    const splitCalField = preset.find((o) => o.name === 'splitCalculation')
    const checkingBillField = preset.find((o) => o.name === 'checkingBillForm')
    const flowLinksField = extension.find((o) => o.name === 'flowLinks')
    const invoiceFormField = data.find((o) => o.name === 'invoiceForm')
    const amortize = preset.filter((v) => v.ability === 'amortize')
    const amortizesField = preset.find((o) => o.name === 'amortizes')
    const presetShowFields = preset.filter((o) => presetShowFieldList.includes(o.name))
    data = data.filter((item) => item.name !== 'payPlanMode' || item.name !== 'detailNo')
    const baseDataPropertiesMap = {}
    data.forEach((line) => (baseDataPropertiesMap[line.name] = line))
    return {
      data,
      extension: extension?.filter((v) => v?.name !== 'flowLinks') ?? [],
      preset,
      apportion,
      baseDataPropertiesMap,
      apportionField,
      splitCalField,
      checkingBillField,
      invoiceFormField,
      flowLinksField,
      amortizesField,
      amortize,
      presetShowFields,
    }
  })
  @node('globalFields', {
    data: [],
    extension: [],
    preset: [],
    apportion: [],
    apportionField: {},
    splitCalField: {},
    baseDataPropertiesMap: {},
    amortizesField: {},
    amortize: [],
  })
  @action
  getBaseDataProperties() {
    return { payload: property.GET('', undefined, undefined, { hiddenLoading: true }) }
  }

  @reducer((action) => action.payload.items)
  @node('staffProperties', [])
  @action
  getStaffProperties() {
    return {
      payload: property.GET('/$type', { type: 'STAFF' }, undefined, { hiddenLoading: true }),
    }
  }

  //#region PowerList

  @reducer((action) => {
    const items = action.payload.items
    const { powerMap, powerCodeMap } = ParsePower(items)
    return {
      ...powerMap,
      powerCodeMap,
      powersList: items,
    }
  })
  @node('powers', {}, true)
  @action
  getPowers() {
    return { payload: powers.GET('', undefined, undefined, { hiddenLoading: true }) }
  }

  //#endregion

  /**
   * 获取AI智能填单权限
   * @returns {{payload: *}}
   */
  @reducer((action) => {
    const abilities = action.payload.data || []
    const aiAutofillPermission = {
      hasAiChat: abilities.includes('AICHAT'),
      abilities,
    }
    return aiAutofillPermission
  })
  @node('aiAutofillPermission', { hasAiChat: false, abilities: [] })
  @action
  getAiAutofillPermission() {
    return { payload: aiAutofillPermission.GET() }
  }

  @reducer((action) => action.payload.items)
  @node('permissions', [])
  @action
  getTotalPermission() {
    return { payload: permission.GET('', undefined, undefined, { hiddenLoading: true }) }
  }

  @reducer
  @action
  getPayeeChangeLog(id) {
    const params = { id, join: 'operatorId,operator,/v1/organization/staffs' }
    return { payload: payees.GET('/$id/log', params) }
  }

  /**
   * 获取上传地址，覆盖默认地址
   * @returns {{payload : *}}
   */

  @reducer((action) => {
    const { value } = action.payload
    const { uploadServiceUrl } = value || {}
    if (uploadServiceUrl) {
      window.UPLOAD_INVOICE_FILE_URL = uploadServiceUrl
    }
    return action.payload.value
  })
  @node('uploadServiceUrl', {})
  @action
  getEnvironment() {
    return {
      payload: corporationSet.GET('/environment', undefined, undefined, { hiddenLoading: true }),
    }
  }

  @reducer
  @action
  getAttachmentToken() {
    return { payload: attachments.GET('/token') }
  }

  @reducer
  @action
  getFlowInfoById({ id, privilegeId = '', flowManager }) {
    const { joinParams, selectEntity } = api.require('@lib/entity.join')
    const { fetchAttachment, fetchInvoice } = api.require('@lib/attachment-fetch')
    const fetchMutilValue = api.require('@lib/mutil-staff-fetch')

    const query = new QuerySelect().filterBy(`id=="${id}"`).select(`${selectEntity()}`).value()
    const params = { id, privilegeId, ...joinParams() }
    if (flowManager) params.flowManager = true
    return {
      payload: flows
        .POST('/flowId/$id', query, params)
        .then(fetchAttachment)
        .then(fetchInvoice)
        .then(fetchMutilValue),
    }
  }

  @reducer
  @action
  getEnumItems(enumCode) {
    return { payload: enumItems.GET(`/$code`, { code: enumCode }) }
  }

  @reducer((action) => action.payload.items)
  @node('apportionSpecifications', [])
  @action
  getApportionTemplates() {
    return { payload: specifications.GET('/actives', { type: 'apportion' }) }
  }

  @reducer((action) => action.payload.value.open)
  @node('isHaveOfficialCardPower')
  @action
  getCorpOfficialCard() {
    return { payload: third.GET('/account/isOpen/$code', { code: '120203' }) }
  }

  @reducer((action) => {
    const { value = {} } = action.payload
    window.CURRENCY_SYMBOL = value.symbol || i18n.get('￥')
    window.CURRENCY_STRCODE = value.strCode || 'CNY'
    return value
  })
  @node('standardCurrency', {})
  @action
  getStandardCurrency() {
    return {
      payload: currencyAction.GET('/standard', undefined, undefined, { hiddenLoading: true }),
    }
  }

  // 获取企业打印模板配置项
  @reducer((action) => {
    const { value = {} } = action.payload
    return value
  })
  @node('showPrintBtn', {})
  @action
  getShowPrintBtn() {
    return {
      payload: flows.GET('/showPrintInvoice', undefined, undefined, { hiddenLoading: true }),
    }
  }

  /**
   * 法人实体多本位币列表
   */

  @reducer((action) => {
    const { items = [] } = action.payload
    return items
  })
  @node('allStandardCurrency', [])
  @action
  getAllStandardCurrency() {
    return {
      payload: currencyAction.GET('/legalEntity/standards', undefined, undefined, {
        hiddenLoading: true,
      }),
    }
  }

  @reducer((action) => action.payload.items)
  @node('allCurrencyRates', [])
  @action
  getEnterpriseAllCurrencyRate() {
    return { payload: currencyAction.GET('/active', undefined, undefined, { hiddenLoading: true }) }
  }

  @reducer((action) => action.payload.value)
  @node('currencyConfig', {})
  @action
  getCurrencyConfig() {
    return { payload: currencyAction.GET('/config', undefined, undefined, { hiddenLoading: true }) }
  }

  @reducer((action) => action.payload.value)
  @node('payeeConfig', {})
  @action
  payeeConfig() {
    return { payload: payeeActionV2.GET('', undefined, undefined, { hiddenLoading: true }) }
  }

  @reducer((action) => action.payload.value)
  @node('payerConfig', {})
  @action
  payerConfig() {
    return { payload: payerActionV2.GET('', undefined, undefined, { hiddenLoading: true }) }
  }

  @reducer((action) => action.payload)
  @node('dimensionItems', {})
  @action
  dimensionItems(items = {}) {
    return { payload: items }
  }

  @reducer((action, state) => {
    const { items, count } = action.payload
    const messageTotal = action.read ? state.message.messageTotal : count
    const messageReadedTotal = action.read ? count : 0
    return { messageList: items, messageTotal, messageReadedTotal }
  })
  @node('message', { messageList: [], messageTotal: 0 })
  @action
  messageList(param) {
    return { payload: message.GET('', param, undefined, { hiddenLoading: true }), read: param.read }
  }

  @reducer
  @action
  updateMessageStatus(id) {
    return { payload: message.PUT('/$id', { id }) }
  }

  @reducer((action) => action.payload.items)
  @node('fullTripTypes', [])
  @action
  getFullTripTypes() {
    const query = new QuerySelect().orderBy('createTime', 'ASC').value()
    return {
      payload: tripTypes.POST('/search', query),
    }
  }

  @reducer((action) => action.payload)
  @node('carbonCopyCount', { count: 0 })
  @action
  getCarbonCopyCount() {
    const query = new QuerySelect()
      .filterBy(`type!="permit"`)
      .filterBy(`state.in("${'UNREAD'}")`)
      .value()
    return {
      payload: carbonCopy.POST('/count', query, undefined, undefined, { hiddenLoading: true }),
    }
  }

  @reducer((action) => action.payload)
  @node('mallRole', {})
  @action
  getMallRole() {
    return {
      payload: messageCenterConfig.GET('/getMallRole', undefined, undefined, {
        hiddenLoading: true,
      }),
    }
  }

  @reducer((action) => {
    return action.payload
  })
  @node('fieldMap', {})
  @action
  getFieldMaps(sourceTotarget) {
    const id = `${Fetch.ekbCorpId}:${sourceTotarget}`
    return { payload: fieldMap.GET('/$id', { id }) }
  }

  @reducer((action) => {
    const items = action.payload.items || []
    const choiceValue = items.length > 0 ? items[0].choiceValue : []
    const lastChoiceMap = {}
    choiceValue?.forEach((it) => {
      lastChoiceMap[it?.fieldName] = it?.lastChoiceValue
    })
    return { choiceValue, lastChoiceMap }
  })
  @node('lastChoice', {})
  @action
  getLastChoice(userId) {
    return { payload: lastChoice.GET('/$id', { id: userId }) }
  }

  @reducer((action) => action.payload)
  @node('CertificateTypeList', [])
  @action
  getCertificateTypeList() {
    return { payload: enumItems.GET('/$id', { id: 'CertificateType' }) }
  }

  @reducer((action) => action.payload.items)
  @node('externalList', [])
  @action
  getExternalList() {
    const params = {
      start: 0,
      count: 2999,
      external: true,
      range: true,
    }
    return this.getStaff(params)
  }

  @reducer
  @action
  getTemporaryToken(expireDate) {
    return { payload: temporaryToken.GET('', { expireDate }) }
  }

  @reducer
  @action
  readAllUnReadMessage() {
    return { payload: message.PUT('/all') }
  }

  @reducer((action) => action.payload.items)
  @node('branchByCityIdList', [])
  @action
  getBranchByCityIdList(data) {
    return { payload: pay.GET('/banks/branchesByCityId', data) }
  }

  @reducer((action) => action.payload)
  @node('dimensionList', [])
  @action
  getDimensionList(param) {
    return { payload: dimensionItems.GET('/byDimensionId/$id/active', param) }
  }

  @reducer((action) => action.payload.items)
  @node('unionBanksList', [])
  @action
  getUnionBanksList(data) {
    return { payload: pay.GET('/banks/getUnionBanks', data) }
  }

  /**
   * 获取全局获取通讯录配置
   * @returns {{payload : *}}
   */
  @reducer((action) => action.payload.value)
  @node('organizationConfig', {})
  @action
  getOrganizationConfig() {
    return {
      payload: setOrganization.GET('/config', undefined, undefined, { hiddenLoading: true }),
    }
  }

  //员工信息
  @reducer
  @action
  getStaffsById(params) {
    const data = {
      ...params,
      // @i18n-ignore
      join: 'id,roles,/v1/organization/staffs/role?join=values.roleDefId,roleDef,/v1/organization/roles&join=values.properties.项目,project,/v1/basedata/dimensionItems/fullName',
      join$1: 'id,bankCardNums,/v1/organization/staffs/bankCardNum',
    }
    return { payload: staffs.GET('/$id', data) }
  }

  @reducer((action) => action.payload.value)
  @node('specificationVersionConfig', { hideVersion: false })
  @action
  getSpecificationVersionedConfig() {
    return { payload: specifications.GET('/config') }
  }

  @reducer((action) => action.payload.value)
  @node('assits', null)
  @action
  getAssistRecode(data) {
    return { payload: assistPlatform.POST('/save', data) }
  }

  @reducer((action) => action.payload.id)
  @node('spaceId')
  @action
  getSpaceId() {
    return { payload: spaceAction.GET('/spaceid') }
  }

  @reducer((action) => action.payload.id)
  @node('dingPanAuthorize')
  @action
  dingPanAuthorize() {
    return { payload: spaceAction.GET('/authorize/add') }
  }

  @reducer((action) => action.payload.id)
  @node('dingPanAuthorizeDownload')
  @action
  dingPanAuthorizeDownload(param = {}) {
    return { payload: spaceAction.GET('/authorize/download/[fileIds]', param) }
  }

  @reducer((action) => action.payload.value)
  @node('MCPermission', null)
  @action
  getMCPermission(permissionName) {
    return { payload: permission.GET('/query', { model: permissionName }) }
  }

  @reducer((action) => {
    const { errorCode } = action.payload
    if (errorCode === 200) {
      return true
    }
  })
  @node('standaloneCorpState', null)
  @action
  getStandaloneCorpState() {
    return { payload: corgSwitch.GET('', undefined, undefined, { hiddenLoading: true }) }
  }

  @reducer((action) => action.payload)
  @node('dimensionFullPathMapForApportion', null)
  @action
  saveDimensionFullPathMap(fullPathMap) {
    return { payload: fullPathMap }
  }

  @reducer((action) => action.payload.value)
  @node('appDownloadUrl')
  @action
  getAppDownloadUrl() {
    return {
      payload: downloadAction.GET('/getUrls', undefined, undefined, { hiddenLoading: true }),
    }
  }

  @reducer(function (action) {
    if (action.typeName === 'setValue') {
      return action.data
    }
    return action.payload.value
  })
  @node('waterMark', null)
  @action
  getWaterMark(typeName, data) {
    return typeName
      ? { typeName, data }
      : { payload: safeSetting.GET('/getText', undefined, undefined, { hiddenLoading: true }) }
  }

  @reducer((action) => action.payload.value)
  @node('invoicePriceAndTaxEditPermission', null)
  @action
  getInvoicePriceAndTaxEditPermission() {
    return {
      payload: invoiceAction.GET('/priceAndTaxSeparatedPermission/staff', undefined, undefined, {
        hiddenLoading: true,
      }),
    }
  }

  @reducer((action) => action.payload.value)
  @node('exportIsTimeLimit', null)
  @action
  exportIsTimeLimit() {
    return { payload: exportIsTimeLimit.POST('') }
  }
  /**
   * 获取委托审批已授权员工列表
   * @returns {{payload : *}}
   */
  @reducer((action) => action.payload.items)
  @node('delegateStaffs', [])
  @action
  getDelegateStaffsAuthorized(delegateType, otherQuery = {}, extraParams = {}) {
    const { getBoolVariation } = app.require('@lib/featbit')
    if (getBoolVariation('delegate-select-staff')) {
      return this.getDelegateStaffsAuthorizedV2(delegateType, otherQuery, extraParams)
    }

    let items = [],
      pages = 1,
      /**
       * slRn4Qikh5R9Ug: 广州市中大管理咨询有限公司的企业id
       * PRP-15313 工单03#4357
       * pageSize > 150时，下面的authorized接口会报空指针异常，影响范围广泛，未找到原因
       * 暂通过改小pageSize解决此hotfix
       */
      pageSize = Fetch.ekbCorpId === 'slRn4Qikh5R9Ug' ? 100 : 3000
    if (PLATFORMINFO?.platform === 'huayu') {
      pageSize = 1000
    }
    const params = {
      start: 0,
      count: pageSize,
      // @i18n-ignore
      // join:
      //   'id,roles,/v1/organization/staffs/role?join=values.roleDefId,roleDef,/v1/organization/roles',    //华宇太慢了 join 数据也没啥用
      delegateType,
    }
    const getDelegateStaffsFn = (delegateType) => {
      return delegateAccess.GET('/staffs/$delegateType', params).then((resp) => {
        if (resp.count != 0) {
          items = items.concat(resp.items)
          params.start = pages * pageSize
          params.delegateType = delegateType
          pages++
          return getDelegateStaffsFn(delegateType)
        }
        return { items }
      })
    }

    return { payload: getDelegateStaffsFn(delegateType) }
  }

  getDelegateStaffsAuthorizedV2(delegateType, otherQuery = {}, extraParams = {}) {
    const CONCURRENCY = 5
    const params = {
      start: 0,
      count: 3000,
      visible: true,
      ...otherQuery,
      delegateType,
    }

    if (Fetch.ekbCorpId === 'slRn4Qikh5R9Ug') {
      params.count = 100
    }
    if (PLATFORMINFO?.platform === 'huayu') {
      params.count = 1000
    }

    const countPerPage = params.count

    const fetchPage = (start) =>
      delegateAccess.GET('/staffs/$delegateType', { ...params, start }).then((r) => r.items || [])

    const getDelegateStaffsFn = async () => {
      const firstResp = await delegateAccess.GET('/staffs/$delegateType', params, undefined, extraParams)
      const totalCount = firstResp.count ?? 0
      const firstPageItems = firstResp.items || []

      if (totalCount <= countPerPage) {
        return { items: firstPageItems }
      }

      const totalPages = Math.ceil(totalCount / countPerPage)
      const remainingStarts = []
      for (let i = 1; i < totalPages; i++) {
        remainingStarts.push(i * countPerPage)
      }

      const allRemainingItems = []
      for (let i = 0; i < remainingStarts.length; i += CONCURRENCY) {
        const batch = remainingStarts.slice(i, i + CONCURRENCY)
        const batchResults = await Promise.all(batch.map(fetchPage))
        allRemainingItems.push(...batchResults.flat())
      }

      return { items: firstPageItems.concat(allRemainingItems) }
    }

    return { payload: getDelegateStaffsFn() }
  }

  @reducer((action) => action.payload.items)
  @node('getCurrencyAll', [])
  @action
  getCurrencyAll() {
    return {
      payload: enumItems.GET('/$currency', { currency: 'currency' }, undefined, {
        hiddenLoading: true,
      }),
    }
  }

  @reducer((action) => action.payload.value)
  @node('standardLimtConfig')
  @action
  getStandardLimtConfig() {
    return { payload: tradeeditionAction.GET('/limitConfig') }
  }

  @reducer((action) => action.payload.value)
  @node('isWhiteList', false)
  @action
  getIsWhiteList() {
    return { payload: isWhiteList.GET('', undefined, undefined, { hiddenLoading: true }) }
  }

  @reducer((action) => action.payload.value)
  @node('isUpgrade')
  @action
  getIsUpgrade() {
    return { payload: isUpgrade.POST('') }
  }

  @reducer((action) => {
    const { Home3, isNav7, BUSINESS_CHARGE, RECEIPT_DOCUMENT } = action?.payload
    const list = []
    if (Home3 && isNav7) {
      list.push({ label: i18n.get('费控管理'), value: '120-hose' })
      if (BUSINESS_CHARGE) {
        list.push({ label: i18n.get('付款管理'), value: '310-corporatePayment' })
      }
      if (RECEIPT_DOCUMENT) {
        list.push({ label: i18n.get('收款管理'), value: '320-corporateReceipt' })
      }
    }
    return { list }
  })
  @node('AppIdList', {}, true)
  @action
  getAppIdList(res) {
    return { payload: res }
  }

  @reducer((action) => action?.payload?.value)
  @node('authEnv')
  @action
  authEnvironment() {
    return { payload: authEnv.GET() }
  }

  @reducer((action) => action?.payload)
  @node('hoseAccessToken')
  @action
  getHoseAccessToken() {
    return { payload: getHoseAccessToken() }
  }

  //toggle敏捷开关管理，通过企业id获取当前企业全部打开的开关
  @reducer((action) => action?.payload?.value)
  @node('toggleManage', false)
  @action
  getToggleAll() {
    return { payload: toggle.GET('/all', undefined, undefined, { hiddenLoading: true }) }
  }

  @reducer()
  @node()
  @action
  getToggleSwitchByName(params) {
    return { payload: toggle.GET('/byCorpId', params) }
  }

  @reducer((action) => action?.payload?.value)
  @node('supplierPortalConfig')
  @action
  fetchSupplierPortalSetting(params) {
    return {
      payload: supplierPortalAction.GET(
        '/getConfigBySupplierId/$supplierArchiveId',
        params,
        undefined,
        { hiddenLoading: true },
      ),
    }
  }

  @reducer((action) => action.payload.items)
  @action
  getMoreStaffsByIds(params) {
    return { payload: staffs.POST('/more', params) }
  }

  @reducer((action) => action.payload.items)
  @action
  searchStaffs(args) {
    const search = () => {
      const params = {
        query: {
          limit: {
            start: 0,
            count: 1000,
            ...(args.limit || {}),
          },
          filterBy: '(authState==true)',
        },
        maskSensitiveInfo: true,
        departmentId: args?.departmentId || undefined,
        visible: !!args?.visible,
        visibleRestrictedStaffId: args?.visibleRestrictedStaffId || undefined,
      }
      if (args.nameList && args.nameList.length > 0) {
        params.query.filterBy += `&& (name.in(${args.nameList
          .map((name) => `"${name}"`)
          .join(',')}))`
      }

      if (args.equalName && typeof args.equalName === 'string') {
        params.query.filterBy += `&& (name=="${args.equalName}")`
      }

      if (args.id && typeof args.id === 'string') {
        params.query.filterBy += `&& (id=="${args.id}")`
      }

      if (args.ids && args.ids.length > 0) {
        params.query.filterBy += `&& (id.in(${args.ids.map((id) => `"${id}"`).join(',')}))`
      }

      if (args.blacklistedIds && args.blacklistedIds.length > 0) {
        params.query.filterBy += `&& (!id.in(${args.blacklistedIds
          .map((id) => `"${id}"`)
          .join(',')}))`
      }

      if (args.searchText) {
        params.query.filterBy += `&& ${`((name.contains("${
          args.searchText
        }"))||(nickName.contains("${args.searchText}"))||(code.contains("${
          args.searchText
        }"))||lower(nameSpell).contains("${(
          args.searchText ?? ''
        ).toLowerCase()}")||(enName.contains("${args.searchText}"))||(cellphone==("${
          args.searchText
        }")))`}`
      }

      const qs = {}
      if (!!args?.needRole) {
        qs.join =
          'id,roles,/v1/organization/staffs/role?join=values.roleDefId,roleDef,/v1/organization/roles'
      }
      return staffsV2.POST('/list', params, qs, null, { hiddenLoading: true })
    }

    return { payload: search() }
  }

  @reducer(function (action) {
    const { value } = action.payload
    api.dispatch(
      this.getSafeSetting('setValue', {
        attachmentSetting: value?.attachmentSetting,
        attachmentOperationControl: value?.attachmentOperationControl,
      }),
    )
    api.dispatch(this.getWaterMark('setValue', value?.watermarkText))
    api.dispatch(this.getFileCanDownload('setValue', value?.allowDownload))
    return value
  })
  @node('safeSettingV3', {})
  @action
  getSafeSettingV3() {
    return { payload: safeSettingV3.GET('/info', undefined, undefined, { hiddenLoading: true }) }
  }

  @reducer((action) => action.payload.items)
  @node('allStaffs', [])
  @action
  getAllStaffs(args) {
    const pageSize = args?.pageSize || (Fetch.ekbCorpId === 'slRn4Qikh5R9Ug' ? 100 : 3000)
    const countPageSize = 1
    const buildParams = (start, count) => ({
      query: {
        limit: {
          start,
          count,
        },
        filterBy: '(authState==true)',
      },
      maskSensitiveInfo: true,
      visible: !!args?.visible,
      visibleRestrictedStaffId: args?.visibleRestrictedStaffId || undefined,
    })

    const qs = {}
    if (!!args?.needRole) {
      qs.join =
        'id,roles,/v1/organization/staffs/role?join=values.roleDefId,roleDef,/v1/organization/roles'
    }
    const fetchPage = (start, count) => staffsV2.POST('/list', buildParams(start, count), qs, null)
    const getStaffsFn = async () => {
      const firstResp = await fetchPage(0, countPageSize)
      const total = firstResp.count || 0
      if (!total) {
        await api.dispatch(this.authStaffDepartmentStaffMap([]))
        await api.dispatch(this.authStaffStaffMap([]))
        return { items: [] }
      }

      const totalPages = Math.ceil(total / pageSize)
      const requests = Array.from({ length: totalPages }, (_v, pageIndex) =>
        fetchPage(pageIndex * pageSize, pageSize),
      )
      const responses = await Promise.all(requests)
      const items = responses.reduce((acc, resp) => acc.concat(resp.items || []), [])

      await api.dispatch(this.authStaffDepartmentStaffMap(items))
      await api.dispatch(this.authStaffStaffMap(items))
      return { items }
    }

    return { payload: getStaffsFn() }
  }

  @reducer((action) => action.payload.items)
  @action
  getVisibleDepartmentsById(args) {
    const { staffId, departmentIds } = args
    return { payload: departments.POST('/tree/visibility/actives', { staffId, departmentIds }) }
  }

  @reducer((action) => action?.payload?.value)
  @node('orgVisiblePower', false)
  @action
  checkOrgVisiblePowerCode(params) {
    return { payload: powers.GET('/corporation', params, undefined, { hiddenLoading: true }) }
  }

  @reducer((action) => action.payload)
  @action
  getDimensionItemsByPage(params = {}) {
    const { dimensionId, searchText = '', parentId = '', ...otherParams } = params
    const defaultParams = {
      filterBy: '(active == true)',
      limit: {
        start: 0,
        count: 100,
      },
    }

    const finalParams = { ...defaultParams, ...otherParams }
    const qs = { dimensionId }

    if (searchText) {
      finalParams.filterBy += ` && (name.contains("${searchText}") || enName.contains("${searchText}") || code.contains("${searchText}"))`
      qs.searchAll = true
    }

    if (parentId) {
      qs.dimensionItemId = parentId
    }

    return {
      payload: dimensionItems.POST('/$dimensionId', finalParams, qs)
    }
  }

  // 部门分页接口
  @reducer((action) => action.payload)
  @action
  getDepartmentsByPage(params = {}) {
    return { payload: departmentsV2.POST('/search', params) }
  }
}

export async function getHoseAccessToken() {
  try {
    const config = await api.dataLoader('@common.authEnv').load()
    const result = await GET(
      '/auth/oauth2/grant/ekb/accessToken',
      {
        corpId: Fetch.ekbCorpId,
        ekbAccessToken: Fetch.accessToken,
        environment: config.environment,
      },
      { baseURL: config.bcGateWayUrl, withCredentials: true, timeout: 100000 },
    )
    return result?.data?.data ?? ''
  } catch (_e) {
    return ''
  }
}

export const actions = new CommonActions()
export const commonActions = actions

export default actions
